import * as Yup from 'yup';
import { IProductEnhancerFormValues } from '../index';

// ! VALIDATION
const productName = Yup.object({
  productName: Yup.string()
    .trim()
    .max(150, 'Limit is 150 characters')
    .required('Product Name is required')
});

const manufacturerName = Yup.object({
  manufacturerName: Yup.string()
    .trim()
    .max(150, 'Limit is 150 characters')
    .required('Manufacturer Name is required')
});

const manufacturerSKU = Yup.object({
  manufacturerSKU: Yup.string()
    .trim()
    .max(50, 'Limit is 50 characters')
    .required('Manufacturer SKU is required')
});

export const productEnhancerValidations = {
  manufacturerSKU,
  manufacturerName,
  productName
};

export const PRODUCT_ENHANCER_VALIDATION_SCHEMAS = Object.entries(
  productEnhancerValidations
).map(([key, value]) => ({
  name: key,
  schema: value
}));

// ! INITIAL VALUES
export const PRODUCT_ENHANCER_INITIAL_VALUES: IProductEnhancerFormValues = {
  productName: '',
  manufacturerName: '',
  manufacturerSKU: ''
};
